module.exports = __webpack_public_path__ + "img/user_injured_bar.91ed0876.svg";